import { type ComponentRoute } from './types';

const allPages: ComponentRoute[] = [
  {
    name: 'Login',
    path: 'login',
    component: () => import('@/views/authentication/auth/LoginPage.vue'),
  },
  {
    name: 'Register',
    path: 'register',
    component: () => import('@/views/authentication/auth/RegisterPage.vue'),
  },
  {
    name: 'Forgot Password',
    path: 'forgot-pwd',
    component: () => import('@/views/authentication/auth/ForgotPwd.vue'),
  },
  {
    name: 'Reset Password',
    path: 'reset-pwd',
    component: () => import('@/views/authentication/auth/ResetPwd.vue'),
  },
  {
    name: 'Error 403',
    path: '/error403',
    component: () => import('@/views/pages/maintenance/error/Error403Page.vue'),
  },
  {
    name: 'Error 404',
    path: '/error',
    component: () => import('@/views/pages/maintenance/error/Error404Page.vue'),
  },
  {
    name: 'Error 500',
    path: '/error500',
    component: () => import('@/views/pages/maintenance/error/Error500Page.vue'),
  },
];

const AuthRoutes = {
  path: '/auth',
  component: () => import('@/layouts/blank/BlankLayout.vue'),
  meta: {
    requiresAuth: false,
  },
  children: allPages,
};

export default AuthRoutes;
